/**
 * BottomSheetContext — signals to other components (FABs) when the
 * BottomNav's "More" sheet is open so they can hide.
 *
 * Lifted to MainLayout so HelpFAB + StevensWidget Shield (rendered as
 * MainLayout siblings of BottomNav) can read the same source of truth.
 */
import { createContext, useContext, useState, type ReactNode } from 'react';

interface BottomSheetState {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

const BottomSheetContext = createContext<BottomSheetState>({
  isOpen: false,
  setOpen: () => {},
});

export function BottomSheetProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);
  return (
    <BottomSheetContext.Provider value={{ isOpen, setOpen }}>
      {children}
    </BottomSheetContext.Provider>
  );
}

export function useBottomSheet() {
  return useContext(BottomSheetContext);
}
